<template>
  <v-list three-line>
    <v-toolbar
      flat
    >
      <v-menu
        bottom
        right
      >
        <template v-slot:activator="{ on }">
          <v-btn
            text
            class="px-2"
            style="margin-left: -8px;"
            v-on="on"
          >
            <v-toolbar-title>{{ $t('TrainingClient.ClassList') }}</v-toolbar-title>
            <v-icon
              right
              class="mr-0"
            >
              {{ mdiMenuDown }}
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/training/list">
            <v-list-item-title>{{ $t('TrainingClient.ClassList') }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="showProgress">
            <v-list-item-title>{{ $t('Workflow.Progress') }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="$config.isShowTrainingCheckinRecord"
            to="/training/attendance"
          >
            <v-list-item-title>{{ $t('Training.Checkin.Record') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer />
      <s-special-class-btn />
    </v-toolbar>

    <template v-for="(item, index) in courses">
      <!--
      <v-divider
        v-if="item.divider"
        :key="index"
        :inset="item.inset"
      />
      -->

      <v-list-item
        v-if="item.pcDetail.allowReg"
        :key="index"
        @click="applyOrShowStatus(item)"
      >
        <v-list-item-avatar v-if="item.pcDetail.publishedByEntityId === 3">
          <v-img
            :src="require('../../assets/SAFP_Logo.jpg')"
          />
        </v-list-item-avatar>
        <v-list-item-avatar
          v-if="item.pcDetail.publishedByEntityId != 3"
          style="height: 55.27px;"
        >
          <v-img
            :src="require('../../assets/CFJJ_Logo.jpg')"
          />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title v-text="$chPtObjData('chinName', item.pcDetail)" />
          <!-- <v-list-item-subtitle>
            {{ item.pcDetail.chinDisplayDateTime }}
            <span v-if="item.pcDetail.chinRegion"> - {{ item.pcDetail.chinRegion }}</span>
          </v-list-item-subtitle> -->
          <v-list-item-subtitle v-html="$chPtObjData('chinDisplayDateTime', item.pcDetail) + $chPtObjData('chinCfjjDisplayDateTime', item.pcDetail)" />
          <div class="hidden-sm-and-down grey--text text--darken-1">
            {{ $t('TrainingClient.Course.Expire') }} {{ momentWithHyphen(item.pcDetail.endEnrollmentDate).format('YYYY-MM-DD') }}
            <span
              v-if="item.afId"
              class="red--text text--darken-1"
            >
              ({{ $t('TrainingClient.Course.Applied') }})
            </span>
          </div>
        </v-list-item-content>
        <!--
        <v-list-item-action>
          <span v-if="item.afId"> (已報讀) </span>
          <span v-if="item.pcDetail.enrollmentProcess === 1"> {{ $t('TrainingClient.Course.EnrollmentProcess.Admission') }} </span>&nbsp;
            <span v-if="item.pcDetail.enrollmentProcess === 2"> {{ $t('TrainingClient.Course.EnrollmentProcess.Finish') }} </span>
          <v-btn
            v-if="!item.afId && item.pcDetail.allowReg"
            :to="`/training/applyForm/${item.pcDetail.id}`"
            fab
            small
          >

          <v-btn
            :to="`/training/applyForm/${item.pcDetail.id}`"
            fab
            small
          >

        <v-icon>arrow_forward</v-icon>
        </v-btn>
        </v-list-item-action>
        -->
        <v-list-item-action v-if="item.pcDetail.outlineDmsId">
          <v-list-item-action-text>
            <s-class-pdf :url="item.pcDetail.outlineDmsId" />
            <!-- <v-btn
              v-if="$config.isBrowser"
              icon
              large
              :loading="downloading"
              @click.stop="downloadFile(item)"
            >
              <v-icon color="deep-orange lighten-2">
                {{ mdiFileDownloadOutline }}
              </v-icon>
            </v-btn> -->
          </v-list-item-action-text>
        </v-list-item-action>
      </v-list-item>
    </template>

    <template v-if="courses.length === 0">
      <div class="my-6 py-6 text-center">
        {{ $t('PublicServant.NoData') }}
      </div>
    </template>

    <s-message-dialog
      :message="$t('Training.Applied')"
      :show.sync="dialog"
    />
  </v-list>
</template>

<style scoped>
  .v-avatar {
    border-radius: 10%;
  }
</style>

<script>

import { mapState } from 'vuex'
import { momentWithHyphen } from '@/utils/datetimeUtil'
import SSpecialClassBtn from './components/SSpecialClassBtn'
import SClassPdf from '../../components/SClassPdf'
import SMessageDialog from '../../components/SMessageDialog'
import courses from '../../store/modules/training/courses'
import store from '../../store'
import { staffModule, coursesModule } from '../../store/moduleName'
import siteIntegrate from '@/api/general/siteIntegrate'
import { BUSINESS_CODE } from '../../constant/constant'
import { mdiMenuDown, mdiFileDownloadOutline } from '@mdi/js'
// import Axios from 'axios'

// We're dynamically registering the
// `courses` store module. This has
// the benefit of only loading this
// module, if it's actually needed.
// Before registering the module, we're
// checking if it's already registered
// which can happen in combination with
// webpacks hot reloading.
if (!store.state[coursesModule]) store.registerModule(coursesModule, courses)

export default {
  components: {
    SSpecialClassBtn,
    SClassPdf,
    SMessageDialog
  },
  data: () => {
    return {
      mdiMenuDown: mdiMenuDown,
      mdiFileDownloadOutline: mdiFileDownloadOutline,
      dialog: false,
      downloading: false
    }
  },
  computed: {
    hrTrainingUrl () {
      return siteIntegrate.getHrTrainingUrl()
    },
    ...mapState({
      courses: state => state[coursesModule].all
    })
  },
  created () {
    this.$store.dispatch(coursesModule + '/getAllCurrentCourse')
    this.$store.dispatch(staffModule + '/getStaff')
  },
  mounted () {
    this.$root.backBtn = false
  },
  methods: {
    applyOrShowStatus: function (item) {
      if (!item.afId) {
        this.$router.push({ name: 'training/applyForm', params: { courseId: item.pcDetail.id.toString() } })
        // this.$router.replace('/training/applyForm/' + item.pcDetail.id)
      } else {
        this.dialog = true
      }
    },
    showProgress () {
      let progressOption = {
        showEndTask: true,
        businessCodes: [BUSINESS_CODE.TRAINING],
        backLink: '/training/list'
      }
      // this.setProgressOption(progressOption)
      this.$router.push({
        path: '/workflow/List',
        query: progressOption
      })
    },
    /* async downloadFile (item) {
      let url = await this.getFileFromServer(item.pcDetail.outlineDmsId)

      // out = new Blob([resp.data])

      let fileName = 'document.pdf'

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      link.click()
      window.URL.revokeObjectURL(url)
    },
    async getFileFromServer (url) {
      this.downloading = true
      return new Promise(resolve => {
        Axios.get(url, {
          responseType: 'blob'
        }).then(
          async resp => {
            this.downloading = false
            if (resp.status === 201 || resp.status === 200) {
              let out = resp.data
              if (out) {
                resolve(window.URL.createObjectURL(out))
              }
            }
          },
          error => {
            this.downloading = false
            console.log(error)
            // this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.DownloadFailed'))
          }
        )
      })
    }, */
    momentWithHyphen: momentWithHyphen
  }
}
</script>
